<template>
  <el-dialog
    :model-value="isOpen"
    width="744px"
    @opened="opened"
    @closed="closed"
    @close="$emit('close')"
    @keydown.esc="$emit('close')"
  >
    <h1 class="tw-mb-8 tw-tracking-wider">
      {{ $t('foreigners.basic_info.activation_dialog.title') }}
    </h1>
    <el-form
      ref="Form"
      :model="form"
      :rules="formRules"
      label-position="top"
      :disabled="isLoading"
      class="tw-flex tw-flex-col tw-mt-3"
      @submit.native.prevent="submitForm"
    >
      <div class="tw-flex tw-items-start">
        <i-form-item
          :label="$t('common.fields.email')"
          prop="email"
        >
          <el-input
            v-model="form.email"
            type="email"
          />
        </i-form-item>
      </div>
    </el-form>
    <template #footer>
      <div class="tw-flex tw-justify-end tw-gap-2 flex-col md:flex-row">
        <i-button
          class="tw-w-40"
          @click="$emit('close')"
        >
          {{ $t('common.actions.cancel') }}
        </i-button>
        <i-button
          type="primary"
          class="tw-w-40"
          :is-loading="isLoading"
          @click="submitForm"
        >
          {{ $t('common.actions.save') }}
        </i-button>
      </div>
    </template>
  </el-dialog>
</template>

<script>
import AuthService from '../../services/AuthService';
import _cloneDeep from 'lodash/cloneDeep';
import _get from 'lodash/get';
import { getValidationError } from '@/helpers';

const FORM_BASE = {
  email: '',
};

export default {
  name: 'EmailActivationDialog',
  props: {
    isOpen: {
      type: Boolean,
      default: false,
    },
    foreignerId: {
      type: Number,
      required: true,
    },
  },
  data() {
    return {
      isLoading: false,
      form: _cloneDeep(FORM_BASE),
      formRules: {
        email: [
          { required: true, message: 'Required', trigger: 'blur' },
          { type: 'email', message: 'Please input correct email address', trigger: 'blur' },
        ],
      },
    };
  },

  methods: {
    opened() {
      this.$refs.Form?.clearValidate();
    },
    closed() {
      this.form = _cloneDeep(FORM_BASE);
      this.$refs.Form?.clearValidate();
    },
    async submitForm() {
      const isValid = await this.$refs.Form.validate().catch(() => false);
      if (!isValid) {
        return;
      }

      this.isLoading = true;

      try {
        const response = await AuthService.sendActivationEmail(
          this.foreignerId,
          this.form.email,
        );

        const message = _get(response, 'data.message');
        this.$message.success({
          message: this.$capitalize(message || 'Success'),
          showClose: true,
        });

        this.$emit('refresh');
        this.$emit('close');
      } catch(error) {
        const errorText = getValidationError(error);

        this.$message.error({
          message: this.$capitalize(errorText || 'Error'),
          showClose: true,
          dangerouslyUseHTMLString: true,
        });
      }

      this.isLoading = false;
    },
  },
};
</script>
